import React from 'react'
import { Dimensions, StyleSheet, Text, View } from 'react-native'
import { Answer } from '../../interfaces/FieldAssesment.interface'
import * as Progress from 'react-native-progress'
import theme from '../../../../../theme'
import styles from './InputEditItemStyles'

const deviceWidth = Dimensions.get('window').width

interface InputEditItemI {
    item: Answer
}

export const InputEditItem = ({ item }: InputEditItemI) => {
    const text = item?.questionOptionSelectedText?.[0] || ''
    const [auditor, date] = text ? text.split('-') : ['', '']

    // Validación adicional para la fecha y hora
    const [fecha, horaCompleta] = date ? date.split(', ') : ['', '']

    // Si no hay hora, evitamos el formateo
    let horaFormateada = ''
    if (horaCompleta) {
        const [hora, minutos] = horaCompleta.split(':')
        const meridiano = horaCompleta.includes('PM') ? 'PM' : 'AM'

        // Solo formateamos si hora y minutos son válidos
        if (hora && minutos) {
            horaFormateada = `${hora}:${minutos} ${meridiano}`
        }
    }

    return (
        <View style={styles.container}>
            <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                <Progress.Circle
                    size={60}
                    progress={0.3} //@Tomy falta conectar acá el progress
                    showsText={true}
                    textStyle={styles.percentageCircle}
                    thickness={6}
                    color={theme.colors.colorPrimary}
                    unfilledColor={theme.colors.disabled}
                    borderWidth={0.1}
                    borderColor={theme.colors.colorSecondary}
                    strokeCap='round'
                    style={{ alignSelf: 'flex-start' }}
                />
            </View>
            <View style={{ flex: 4 }}>
                {/*<Text style={styles.title}>{item.question}</Text>*/}
                <Text style={styles.auditor}>{'Auditor: ' + (auditor || 'N/A')}</Text>
                <Text style={styles.date}>{'Fecha: ' + (fecha ? `${fecha}, ${horaFormateada}` : 'N/A')}</Text>
            </View>
        </View>
    )
}
